module.exports = __webpack_public_path__ + "static/img/icon_gdt_code.a30aa602.png";